<div class="select__input">
  <select [id]="fp.id" [(ngModel)]="value">
    <option value=""></option>
    <option *ngFor="let bv of fp.bvs" [value]="bv.id">{{ cameleonService.getBVDescription(bv) }}</option>
  </select>
</div>
